import { Box, CircularProgress } from '@mui/material'
import type { GetInternalLabelMasterResponse } from '@ulysses-inc/harami_api_client'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useHistory, useParams } from 'react-router-dom'
import { useQueryLabelMaster } from 'src/features/labelMaster/api/useQueryLabelMaster'
import { type LabelMasterFormData } from 'src/features/labelMaster/form/LabelMasterSaveForm'
import { EditHeader } from './EditHeader'
import { LabelMasterEdit } from './LabelMasterEdit'

const toFormData = (
  data: GetInternalLabelMasterResponse,
): LabelMasterFormData => ({
  name: data.name,
  code: data.code,
  barcodeId: data.barcodeId,
  status: data.status,
})

export const LabelMasterEditPage = () => {
  const { labelMasterId } = useParams<{ labelMasterId: string }>()

  useEffect(() => {
    document.title = 'ラベル検査 | AIラベル検査 | カミナシ レポート'
  }, [])

  if (!labelMasterId) {
    return null
  }

  return <LabelMasterEditPageContent labelMasterId={labelMasterId} />
}

const LabelMasterEditPageContent = ({
  labelMasterId,
}: {
  labelMasterId: string
}) => {
  const history = useHistory()
  const { data, isLoading } = useQueryLabelMaster(labelMasterId)

  if (isLoading || !data) {
    return (
      <Box bgcolor="background.grayLight" height="100vh" overflow="hidden">
        <EditHeader onBack={() => history.goBack()} canSave={false} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'calc(100vh - 64px)',
          }}
        >
          <CircularProgress />
        </Box>
      </Box>
    )
  }

  const defaultValues = toFormData(data)

  return (
    <FormProviderWrapper defaultValues={defaultValues}>
      <LabelMasterEdit labelMasterId={labelMasterId} />
    </FormProviderWrapper>
  )
}

const FormProviderWrapper = ({
  defaultValues,
  children,
}: {
  defaultValues: LabelMasterFormData
  children: React.ReactNode
}) => {
  const methods = useForm<LabelMasterFormData>({ defaultValues })
  return <FormProvider {...methods}>{children}</FormProvider>
}
